<template>
  <div
    class="ah-header"
    :class="classHeaderUc"
  >
    <div
      class="ah-header__content"
    >
      <header
        ref="header"
        class="ah-header__header"
        :class="isRtl ? 'ah-header__header--is-rtl' : ''"
      >
        <div
          class="ah-header__logo ah-header__logo--desktop"
        >
          <!-- @slot Use this slot to pass the logo -->
          <slot
            v-if="$slots.logo"
            name="logo"
          />
          <AhLogo
            v-else
            :brand-data="brandData"
            @logo:clicked="logoClicked"
          />
        </div>

        <div
          class="ah-header__navigation"
        >
          <AhHeaderNavigation
            v-if="navItemsList?.length || isNavIsHidden"
            :list-items="navItemsList"
            :is-nav-hidden="isNavIsHidden"
            :mobile-breakpoint="mobileBreakpoint"
            :effect="effect"
            :geoloc="geoloc"
            :currency="currency"
            @nav:panel:clicked="navPanelClick"
            @nav:panel:closed="navPanelClick"
            @menu:panel:clicked="menuPanelClick($event)"
            @burgerMenu:open="burgerMenuClicked(true)"
            @burgerMenu:close="burgerMenuClicked(false)"
          >
            <template
              v-if="$slots.geoloc"
              #geoloc
            >
              <!-- @slot Use this slot to pass the geoloc component -->
              <slot
                v-if="$slots.geoloc"
                name="geoloc"
              />
            </template>
            <template
              v-if="$slots.currency"
              #currency
            >
              <!-- @slot Use this slot to pass the geoloc component -->
              <slot
                v-if="$slots.currency"
                name="currency"
              />
            </template>
          </AhHeaderNavigation>
        </div>

        <div

          class="ah-header__logo ah-header__logo--mobile"
          :class="{ 'ah-header__logo--offset': !$slots.loginnav }"
        >
          <!-- @slot Use this slot to pass the logo -->
          <slot
            v-if="$slots.logo"
            name="logo"
          />
          <AhLogo
            v-else
            :brand-data="brandData"
            @logo:clicked="logoClicked"
          />
        </div>

        <div
          id="loginnav"
          class="ah-header__loginnav"
        >
          <!-- @slot Use this slot to pass the login nav component -->
          <slot
            v-if="$slots.loginnav"
            name="loginnav"
          />
        </div>
      </header>
    </div>
  </div>
</template>

<script>
  import AhHeaderNavigation from '../organisms/AhHeaderNavigation/AhHeaderNavigation.vue';
  import AhLogo from '../molecules/AhLogo/AhLogo.vue';

  export default {
    name: 'AhHeader',
    components: { AhHeaderNavigation, AhLogo },
    provide() {
      return {
        $lang: () => this.lang,
        $imgFromDynamicMedia: this.imgFromDynamicMedia,
        $dynamicMediaParams: this.dynamicMediaParams,
        $mobileWhParam: this.mobileWhParam,
        $tabletWhParam: this.tabletWhParam,
      };
    },
    inject: {
      fromPre: {
        from: 'prerendering',
        default: false
      },
    },
    props: {
      /**
       * A json object representing items to be displayed to be required.
       */
      listItems: {
        type: Array,
        default: () => []
      },
      /**
       * Set the position to sticky.
       */
      isSticky: {
        type: Boolean,
        default: false,
      },
      /**
       * Set the sticky direction 'down' or 'up'
       */
      stickyDirection: {
        type: String,
        default : 'down'
      },
      /**
       * An object describing the logo.
       */
      brandData: {
        type: Object,
        default: () => ({
          linkUrl: 'https://all.accor.com',
          imgSrc: 'https://all.accor.com/components/header/assets/icons/brands/all.svg',
          imgAlt: 'Accor Live Limitless',
          logoWidth:76,
          logoHeight:46
        })
      },
      /**
       * Set the mobile breakpoint default is 1023.
       */
      mobileBreakpoint: {
        type: [Number, Boolean],
        default: 1023
      },
      /**
       * Supercharge the header with custom classes.
       */
      customClass: {
        type: String,
        default: '',
      },
      /**
       * Lang for i18n.
       */
      lang: {
        type: String,
        default: 'en',
      },
      pos: {
        type: String,
        default: null,
      },
      geoloc: {
        type: Object,
        default: null,
      },
      // {label:'UAD', symbole:'$'}
      currency : {
        type: Object,
        default: null,
      },
      domain: {
        type: String,
        default: '',
      },
      isNavHidden: {
        type: Boolean,
        default: false
      },
      // Param for Adobe dynamic media
      imgFromDynamicMedia: {
        type: Boolean,
        default: true,
      },
      dynamicMediaParams: {
        type: Object,
        default: () => ({
          'push' : {
            'small': {
              fmt: 'webp',
              hei: '188',
              wid: '335',
              ratio: '16by9',
              media: '(max-width: 47.9375rem)'
            },
            'medium': {
              fmt: 'webp',
              hei: '172',
              wid: '307',
              ratio: '16by9',
              media: '(min-width: 48rem) and (max-width: 63.9375rem)'
            },
            'large': {
              fmt: 'webp',
              hei: '513',
              wid: '411',
              ratio: '8by10',
              media: '(min-width: 64rem) and (max-width: 79.9375rem)'
            },
            'xlarge': {
              fmt: 'webp',
              hei: '673',
              wid: '539',
              ratio: '8by10',
              media: '(min-width: 80rem) and (max-width: 89.9375rem)'
            },
            'xxlarge': {
              fmt: 'webp',
              hei: '713',
              wid: '571',
              ratio: '8by10',
              media: '(min-width: 90rem)'
            },
          },
          'widget': {
            'small': {
              fmt: 'webp',
              hei: '188',
              wid: '335',
              ratio: '16by9',
              media: '(max-width: 47.9375rem)'
            },
            'medium': {
              fmt: 'webp',
              hei: '172',
              wid: '307',
              ratio: '16by9',
              media: '(min-width: 48rem) and (max-width: 63.9375rem)'
            },
            'large': {
              fmt: 'webp',
              hei: '274',
              wid: '411',
              ratio: '3by2',
              media: '(min-width: 64rem) and (max-width: 79.9375rem)'
            },
            'xlarge': {
              fmt: 'webp',
              hei: '359',
              wid: '539',
              ratio: '3by2',
              media: '(min-width: 80rem) and (max-width: 89.9375rem)'
            },
            'xxlarge': {
              fmt: 'webp',
              hei: '380',
              wid: '571',
              ratio: '3by2',
              media: '(min-width: 90rem)'
            },
          },
        })
      },
      mobileWhParam: {
        type: String,
        default: '&wid=583&hei=328'
      },
      tabletWhParam: {
        type: String,
        default: '&wid=285&hei=190'
      },
      /**
       * Set the position to sticky.
       */
      enableTracking: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isNavIsHidden : this.isNavHidden,
        navItemsList : [],
        scrollDirection: null,
        lastScrollPosition: 0,
        hidden: false,
        aemApiPath : 'https://aem-api.accor.com/accorApi/header?brand=all',
        posLangQueryParam : `&lang=${this.lang || 'en'}&pos=${this.pos || ''}`,
        windowWidth: null,
      };
    },
    computed: {
      classHeaderUc() {
        let classes = [this.customClass];
        this.isSticky && classes.push('ah-header--is-sticky');
        if(this.isNavIsHidden) {
          if(!this.$slots.loginnav && !this.$slots.geoloc) {
            classes.push('ah-header--is-logonav');
          }
          if(this.$slots.loginnav && !this.$slots.geoloc) {
            classes.push('ah-header--is-loginnav');
          }
          classes.push('ah-header--is-navhidden');
        }
        return classes;
      },
      brandDataWidth () {
        return this.brandData?.logoWidth;
      },
      isMobile () {
        return this.windowWidth <= this.mobileBreakpoint;
      },
      isRtl() {
        return this.lang === 'ar';
      },
      effect() {
        return this.isRtl ? 'ah-slide-right' : 'ah-slide-left';
      },
    },
    watch: {
      scrollDirection: {
        handler() {
          window.cancelAnimationFrame(this.animationLong);
          this.animationLong = null;
          this.animationStart = null;
          this.animationLong = window.requestAnimationFrame(
            this.animationHandler
          );
        },
      },
    },
    async created() {
      if((!this.listItems || !this.listItems.length)  && !this.isNavIsHidden) {
        this.navItemsList = await this.fetchMenuI18N(this.aemApiPath + this.posLangQueryParam);
      } else {
        this.navItemsList = this.listItems;
      }
    },
    mounted() {
      this.windowWidth = window.innerWidth;
      if(this.isSticky) {
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      }
    },
    beforeDestroy() {
      if(this.isSticky) {
        window.removeEventListener('scroll', this.scrollHandler, {
          passive: true,
        });
      }
    },
    methods: {
      async fetchMenuI18N(jsonPath) {
        try {
          let menuData = await fetch(jsonPath);
          if (!menuData.ok) throw menuData;
          menuData = await menuData.json();
          return menuData;
        } catch (error) {
          if (error && (error.status === 404 || error.status === 500)) {
            console.warn(
              'An error occured while retrieving the data header from aem API. Retrying, please wait.'
            );
            this.isNavIsHidden = true;
          }
        }
      },
      animationHandler(timestamp) {
        if (!this.animationStart) this.animationStart = timestamp;
        const progress = timestamp - this.animationStart;
        if (progress < this.animationDuration) {
          this.animationLong = window.requestAnimationFrame(
            this.animationHandler
          );
          return;
        }
        if(this.stickyDirection === 'down' && (this.scrollDirection == 'down' || this.scrollDirection == 'up')) {
          this.hidden = false;
        }
        if(this.stickyDirection === 'up' && this.scrollDirection == 'down') {
          this.hidden = true;
        } else {
          this.hidden = false;
        }
      },
      scrollHandler() {
        const currentScrollPosition =
          window.pageYOffset || document.documentElement.scrollTop;
        if (currentScrollPosition >= this.$refs.header.offsetHeight) {
          this.scrollDirection =
            currentScrollPosition < this.lastScrollPosition ? 'up' : 'down';
        }
        this.lastScrollPosition = currentScrollPosition;
      },
      navPanelClick (data) {
        /**
         * Triggers when nav panel is clicked.
         *
         * @param     {object}  data
         * @param     {string}  data.id        id of the item
         * @param     {string}  data.text      text of the item
         * @param     {boolean} data.opened   tell if the item is opened or closed
         * @param     {boolean} data.tracking tracking set in the item
         */
        this.$emit('nav:panel:clicked', data);
        if(data.opened) {
          this.trackEvents({
            menu_position: data.position,
            menu_label: data.parent ? `${data.parent} - ${data.tracking}` : data.tracking,
          });
        }
      },
      menuPanelClick (data) {
        this.trackEvents({
          menu_position: data.position,
          menu_label: data?.more ? (data.parent && typeof data.parent === 'object' ? `more - ${data.parent.tracking} - ${data.tracking}` : `more - ${data.tracking}`) : data.parent ? `${data.parent} - ${data.tracking}` : data.tracking,
        });
        
        /**
         * Triggers when nav panel is clicked.
         *
         * @param     {object}  data
         * @param     {string}  data.id       id of the item
         * @param     {string}  data.text     text of the item
         * @param     {string}  data.url      url of the item
         * @param     {boolean} data.opened   tell if the item is opened or closed
         * @param     {boolean} data.tracking tracking set in the item
         */
        this.$emit('menu:panel:clicked', data);
      },
      burgerMenuClicked (open) {
        /**
         * Triggers when burger menu is clicked.
         *
         * @param {object} open can be open or close
         */
        this.$emit(`burgerMenu:${open ? 'open' : 'close'}`);
        if( this.enableTracking && window?.TagManager) { 
          const eventData = {
            event: 'GA4event',
            eventName: open ? 'menu_open' : 'menu_close',
            event_data: {
              pagename: window?.dataLayer?.filter(elt => elt.event === 'push_dynamic_datas')[0]?.pagename || location.href,
            }
          };
          TagManager.trackEvent(eventData);
        }
      },
      trackEvents (data) {
        if( this.enableTracking && window?.TagManager) {
          const eventData = {
            event: 'GA4event',
            eventName: 'menu_interact',
            event_data: {
              pagename: window?.dataLayer?.filter(elt => elt.event === 'push_dynamic_datas')[0]?.pagename || location.href,
              ...data
            }
          };
          TagManager.trackEvent(eventData);
        }
      },
      logoClicked () {
        /**
         * Triggers when logo is clicked.
         */
        this.$emit('logo:clicked');
        // Tracking 
        if( this.enableTracking && window?.TagManager) { 
          const eventData = {
            event: 'GA4event',
            eventName: 'menu_interact',
            event_data: {
              menu_position: '',
              menu_label: 'logo',
              pagename: window?.dataLayer?.filter(elt => elt.event === 'push_dynamic_datas')[0].pagename || location.href,
            }
          };
          TagManager.trackEvent(eventData);
        }

      },
    }
  };
</script>
